import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';

import {
  DEFAULT_CURRENCY,
  DEFAULT_LOCALE,
  DEFAULT_TIMEZONE,
} from './constants';

const getMultilingualLocale = (flowAPI: ControllerFlowAPI) => {
  const { multilingual } = flowAPI.controllerConfig.wixCodeApi.window;

  if (!multilingual.isEnabled) {
    return;
  }

  return multilingual.siteLanguages.find(
    ({ languageCode }) => languageCode === multilingual.currentLanguage,
  )?.locale;
};

export const getRegionalSettings = (flowAPI: ControllerFlowAPI) => {
  let locale =
    flowAPI.controllerConfig.wixCodeApi.site.regionalSettings ??
    flowAPI.controllerConfig.wixCodeApi.site.language;

  const multilingualLocale = getMultilingualLocale(flowAPI);

  if (multilingualLocale) {
    locale = multilingualLocale;
  }

  return locale;
};

export const getSiteLocale = (flowAPI: ControllerFlowAPI) =>
  getMultilingualLocale(flowAPI) ??
  flowAPI.controllerConfig.wixCodeApi.site.language ??
  DEFAULT_LOCALE;

export interface Instance {
  metaSiteId?: string;
  appDefId?: string;
  biToken?: string;
  instanceId?: string;
  aid?: string;
  siteOwnerId?: string;
  siteIsTemplate?: boolean;
  uid?: string;
}

export const getInstance = (flowApi: ControllerFlowAPI): Instance => {
  const signedInstance = flowApi.controllerConfig.appParams.instance;

  try {
    const instance = signedInstance.split('.')[1];

    if (!instance) {
      return {};
    }

    return JSON.parse(atob(instance));
  } catch (e) {
    return {};
  }
};

export const isTemplateView = (flowApi: ControllerFlowAPI) => {
  const instance = getInstance(flowApi);

  return instance?.siteIsTemplate ?? false;
};

export const getSiteCurrency = (flowAPI: ControllerFlowAPI) =>
  flowAPI.controllerConfig.wixCodeApi.site.currency || DEFAULT_CURRENCY;

export const getSiteTimezone = (flowAPI: ControllerFlowAPI) =>
  flowAPI.controllerConfig.wixCodeApi.site.timezone || DEFAULT_TIMEZONE;
